import styled from '@emotion/styled';
import React from 'react';
import { theme } from '../../theme';
import { ProgressBar, ProgressBarColorVariant } from '../progress-bar/ProgressBar';
import { Icon } from '../icon';
const ICON_SIZE = '24px';
const Card = styled.div `
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	width: 100%;
	padding: ${theme.spacing.space40};
	background-color: ${({ isComplete }) => isComplete ? theme.colors.GR20 : theme.colors.BB20};
	border-radius: ${theme.radii.radii30};
	gap: ${theme.spacing.space20};
`;
const TitleRow = styled.div `
	display: flex;
	flex-direction: row;
	width: 100%;
	align-items: center;
	justify-content: space-between;
	gap: ${theme.spacing.space10};
	/* Ensures no layout shift when show/hiding the completion icon */
	min-height: ${ICON_SIZE};
`;
const Title = styled.span `
	${theme.typography.IR90};
	color: ${({ isComplete }) => isComplete ? theme.colors.LM_NU80 : theme.colors.BB200};
	font-size: 1rem;
	line-height: 125%;
`;
const CheckBoxCircle = styled.div `
	/* A round circle with a GR100 background fixed width and height 24x24*/
	border-radius: 50%;
	width: ${ICON_SIZE};
	height: ${ICON_SIZE};
	background-color: ${theme.colors.GR100};
`;
const Progress = styled.div `
	display: flex;
	flex-direction: row;
	width: 100%;
	align-items: center;
	justify-content: center;
	gap: ${theme.spacing.space20};
`;
const StepCount = styled.span `
	${theme.typography.IB90};
	color: ${({ isComplete }) => isComplete ? theme.colors.LM_NU80 : theme.colors.BB200};
	font-size: 0.875rem;
	line-height: 125%;
`;
export const Task = ({ title, totalSteps, currentSteps, className, }) => {
    const sections = Array(totalSteps).fill(1);
    const isComplete = currentSteps >= totalSteps;
    const variant = isComplete ? ProgressBarColorVariant.Green : ProgressBarColorVariant.Blue;
    return (React.createElement(Card, { className: className, isComplete: isComplete, "data-testid": "task-card" },
        React.createElement(TitleRow, null,
            React.createElement(Title, { isComplete: isComplete }, title),
            isComplete && (React.createElement(CheckBoxCircle, { "data-testid": "task-checkbox-complete" },
                React.createElement(Icon, { name: "Checkmark", color: theme.colors.LM_NU0 })))),
        React.createElement(Progress, { className: className },
            React.createElement(ProgressBar, { sections: sections, progress: currentSteps, variant: variant }),
            React.createElement(StepCount, { isComplete: isComplete },
                currentSteps,
                "/",
                totalSteps))));
};
//# sourceMappingURL=Task.js.map